(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["genesi-feedback"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('genesi-feedback')){
  customElements.define('genesi-feedback',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.addEventListener('click',event=>{
        const button=event.target.closest('button');
        if(button?.hasAttribute('data-direction')){
          const track=this.querySelector('.gf__track');
          const card=track.querySelector('.gf__card');
          if(card)track.scrollBy({left:Number(button.dataset.direction)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        }
        if(button?.hasAttribute('data-open')){
          const dialog=Array.from(this.querySelectorAll('dialog')).find(item=>item.dataset.dialog===button.dataset.open);
          if(dialog&&!dialog.open)dialog.showModal();
        }
        if(button?.hasAttribute('data-close'))button.closest('dialog').close();
        if(event.target.tagName==='DIALOG'){
          const bounds=event.target.getBoundingClientRect();
          if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)event.target.close();
        }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
